import { useState } from "react";
import { useTranslation } from "react-i18next";
import DateFnsUtils from '@date-io/date-fns';
import { FormControl } from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { getDefaultLocale } from "../../lib/utils/dateUtil";

function YearMonthDateRangeSelector ( props ) {

    const { t } = useTranslation ();

    const { onChange } = props;
    const date = new Date ();
    const firstMonth = new Date(date.getFullYear(), 0);
    const lastMonth = new Date(date.getFullYear(), 11);

    const [ from, setFrom ] = useState (firstMonth);
    const [ to, setTo ] = useState (lastMonth);

    // 시작이 끝보다 늦으면 다른 쪽을 같은 달로 맞추고, 화면에 보이는 그 기간을 그대로 알린다
    const onFromChange = ( newFrom ) => {

        const newTo = newFrom > to ? newFrom : to;

        setFrom ( newFrom );
        setTo ( newTo );

        if ( onChange ) {

            onChange ( newFrom, newTo );

        }

    }

    const onToChange = ( newTo ) => {

        const newFrom = from > newTo ? newTo : from;

        setTo ( newTo );
        setFrom ( newFrom );

        if ( onChange ) {

            onChange ( newFrom, newTo );

        }

    }

    return (

        <div style={{marginTop: "8px", marginLeft: "20px", }}>

            <MuiPickersUtilsProvider   locale={getDefaultLocale(t)} utils={DateFnsUtils}>
                <FormControl>
                    <KeyboardDatePicker
                        variant="inline"
                        autoOk
                        disableToolbar
                        format={"yyyy/MM"}
                        margin="normal"
                        views={["year","month"]}
                        style={{ marginRight: "16px", marginTop: "5px", width: "140px"}}
                        value={from}
                        onChange={onFromChange}
                    />
                </FormControl>
            </MuiPickersUtilsProvider>

            <span style={{display : "inline-block" ,verticalAlign : "middle", margin : "10px"}}>~</span>
            <MuiPickersUtilsProvider locale={getDefaultLocale(t)} utils={DateFnsUtils}>
                <FormControl>
                    <KeyboardDatePicker
                        variant="inline"
                        disableToolbar
                        autoOk
                        format={"yyyy/MM"}
                        views={["year","month"]}
                        margin="normal"
                        style={{marginLeft: "16px", marginTop: "5px", width: "140px"}}
                        value={to}
                        onChange={onToChange}
                    />
                </FormControl>
            </MuiPickersUtilsProvider>

        </div>

    );

}

export default  YearMonthDateRangeSelector;

